import Image from "next/future/image";

import { Col, Container, Row } from "react-bootstrap";

import SectionHead from "../Shared/SectionHead";

import { useIntl } from "react-intl";

const About = ({ aboutData }) => {
  const { locale, formatMessage } = useIntl();

  return (
    <>
      <div className="about-s" id="aboutUs">
        <Container>
          <div className="about-top">
            <Row>
              <Col md={12} xs={12}>
                <SectionHead title={formatMessage({ id: "aboutUs" })} />
              </Col>
            </Row>
          </div>
          <div className="about-bottom">
            <Row className="gy-4 align-items-stretch">
              <Col xl={6} lg={6} md={12} xs={12}>
                <div
                  className="ab-img"
                  data-aos="fade-up"
                  data-aos-duration="300"
                  data-aos-delay="100"
                >
                  <Image
                    src={`${process.env.NEXT_PUBLIC_MAIN_URL}${aboutData?.[0].image}`}
                    width={1000}
                    height={1000}
                    alt="about imae"
                    loading="lazy"
                  />
                </div>
              </Col>
              <Col xl={6} lg={6} md={12} xs={12}>
                <div className="ab-data">
                  <ul>
                    <li
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="200"
                    >
                      <h4>{aboutData?.[0]?.vision?.title?.[locale]}</h4>
                      <div
                        className="data-description"
                        dangerouslySetInnerHTML={{
                          __html: aboutData?.[0]?.vision?.description?.[locale],
                        }}
                      />
                    </li>
                    <li
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="300"
                    >
                      <h4>{aboutData?.[0]?.message?.title?.[locale]}</h4>

                      <div
                        className="data-description"
                        dangerouslySetInnerHTML={{
                          __html:
                            aboutData?.[0]?.message?.description?.[locale],
                        }}
                      />
                    </li>
                    <li
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="300"
                    >
                      <h4>{aboutData?.[0]?.services?.title?.[locale]}</h4>

                      <div
                        className="data-description"
                        dangerouslySetInnerHTML={{
                          __html:
                            aboutData?.[0]?.services?.description?.[locale],
                        }}
                      />
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default About;
